window.googletag = window.googletag || {};
const googletag = window.googletag;
googletag.cmd = googletag.cmd || [];
googletag.cmd.push(() => {
  googletag.pubads().disableInitialLoad();
  googletag.enableServices();
});
